// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3pe1G","introText":"introText__2qLz_","image":"image__3Haqt","mobileHearts":"mobileHearts__2IGyq","mobileSparkles":"mobileSparkles__7zz1i","desktopHearts":"desktopHearts__3aGKl","desktopSparkles":"desktopSparkles__241q1"};


//////////////////
// WEBPACK FOOTER
// ./components/Intro/style.css
// module id = l8Hw
// module chunks = 0